import React, {Component} from 'react';
import BaseBtn from "../../Buttons/BaseBtn";

class PopupAdminReading extends Component {
    // {/*대목차 : grade, 소목차 : section, 제목 : title*/}
    state = {
        fileName: '',
        grade: '',
        section: '',
        title: '',
        contents: ''
    }

    componentDidMount() {
        this.setState({
            fileName: this.props.fileName,
            grade: this.props.grade,
            section: this.props.section,
            title: this.props.title,
            contents: this.props.contents,
        });
    }

    closePopup = () => {
        this.props.closePopup();
    }

    onInputChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    onHandleSubmit = () => {
        this.props.readingSaveData(this.state);
    }

    render() {
        return (
            <div className="popupWrapper">
                <div className="popup">
                    <div className="alertWrapper" style={{width: '1000px'}}>
                        <dl className="alert">
                            <dt className="title">
                                <span>Contents</span>
                                <button onClick={this.closePopup} className="btnClose">닫기</button>
                            </dt>
                            <dd className="contents">
                                <div>
                                    <div className="desc" style={{display: 'block'}}>
                                        <div style={{fontSize: '15pt', textAlign: 'left', display: 'block'}}>
                                            <span>File Name : </span>
                                            <input name='fileName' onChange={this.onInputChange} value={this.state.fileName}/>
                                        </div>
                                        <div style={{marginTop: '10px', fontSize: '15pt', textAlign: 'left', display: 'block'}}>
                                            <span>대목차 : </span>
                                            <input name='grade' onChange={this.onInputChange} value={this.state.grade}/>
                                        </div>
                                        <div style={{marginTop: '10px', fontSize: '15pt', textAlign: 'left', display: 'block'}}>
                                            <span>소목차 : </span>
                                            <input name='section' onChange={this.onInputChange} value={this.state.section}/>
                                        </div>
                                        <div style={{marginTop: '10px', fontSize: '15pt', textAlign: 'left', display: 'block'}}>
                                            <span>제목 : </span>
                                            <input name='title' onChange={this.onInputChange} value={this.state.title}/>
                                        </div>
                                        <div style={{marginTop: '10px', textAlign: 'left', fontSize: '20pt', display: 'block'}}>
                                            <span style={{fontSize: '15pt'}}>Contents : </span>
                                            <textarea style={{width: '95%', height: '500px'}} name='contents' onChange={this.onInputChange} value={this.state.contents}/>
                                        </div>
                                    </div>
                                    <BaseBtn btnColor="deepPink" btnName="읽기 저장" onClick={this.onHandleSubmit}/>
                                </div>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopupAdminReading;


// WEBPACK FOOTER //
// ./src/components/Containers/PopupAdminReading/index.js